import {
  LabelOptionsRewriteDto,
  LabelOptionsRewriteCarrierDto,
  LabelOptionsRewriteSenderDto,
  LabelOptionsRewriteReceiverDto,
  LabelOptionsRewriteDropOffsDto,
  LabelOptionsRewriteDropOffOptionDto,
  LabelOptionsRewriteModel,
  LabelOptionsRewriteCarrierModel,
  LabelOptionsRewriteSenderModel,
  LabelOptionsRewriteReceiverModel,
  LabelOptionsRewriteDropOffsModel,
  LabelOptionsRewriteDropOffOptionModel,
  GetLabelOptionsRewriteResp,
} from '../types/label-options'

export const transformLabelOptionsRewriteDropOffOption = ({
  type,
  label_types,
  free_reusable_packaging_available,
  formatted_dimensions,
  contactless,
  requires_pickup_time,
  requires_pickup_date,
  printer_requirement,
}: LabelOptionsRewriteDropOffOptionDto): LabelOptionsRewriteDropOffOptionModel => ({
  type,
  labelTypes: label_types,
  freeReusablePackagingAvailable: free_reusable_packaging_available,
  formattedDimensions: formatted_dimensions,
  contactless: contactless ?? false,
  requiresPickupTime: requires_pickup_time ?? false,
  requiresPickupDate: requires_pickup_date ?? false,
  printerRequirement: printer_requirement,
})

export const transformLabelOptionsRewriteDropOffs = ({
  type,
  provides_nearby_drop_off_points,
  options,
}: LabelOptionsRewriteDropOffsDto): LabelOptionsRewriteDropOffsModel => ({
  type,
  providesNearbyDropOffPoints: provides_nearby_drop_off_points,
  options: options.map(transformLabelOptionsRewriteDropOffOption),
})

export const transformLabelOptionsRewriteReceiver = ({
  name,
  photo_url,
}: LabelOptionsRewriteReceiverDto): LabelOptionsRewriteReceiverModel => ({
  name,
  photoUrl: photo_url,
})

export const transformLabelOptionsRewriteSender = ({
  phone_number,
  phone_number_requirement,
  photo_url,
}: LabelOptionsRewriteSenderDto): LabelOptionsRewriteSenderModel => ({
  phoneNumber: phone_number,
  phoneNumberRequirement: phone_number_requirement,
  photoUrl: photo_url,
})

export const transformLabelOptionsRewriteCarrier = ({
  name,
  icon_url,
  terms_and_conditions,
}: LabelOptionsRewriteCarrierDto): LabelOptionsRewriteCarrierModel => ({
  name,
  iconUrl: icon_url,
  termsAndConditions: terms_and_conditions,
})

export const transformLabelOptionsRewrite = ({
  screen_title,
  action_title,
  shipment_entry_type,
  carrier,
  sender,
  receiver,
  drop_offs,
  shipping_order_id,
  info_banner_text,
  info_banner_type,
}: LabelOptionsRewriteDto): LabelOptionsRewriteModel => ({
  screenTitle: screen_title,
  actionTitle: action_title,
  shipmentEntryType: shipment_entry_type,
  carrier: transformLabelOptionsRewriteCarrier(carrier),
  sender: transformLabelOptionsRewriteSender(sender),
  receiver: transformLabelOptionsRewriteReceiver(receiver),
  dropOffs: drop_offs.map(transformLabelOptionsRewriteDropOffs),
  shippingOrderId: shipping_order_id,
  infoBannerText: info_banner_text,
  infoBannerType: info_banner_type,
})

export const transformLabelOptionsRewriteResponse = (response: GetLabelOptionsRewriteResp) =>
  transformLabelOptionsRewrite(response.label_options)
